import React from 'react';
export const userContext = React.createContext({user:{isSignedIn: false},updateUser: () => {}});